import {useDisclosure} from '@chakra-ui/react';
import {useRestaurantBySlug} from 'api/queries';
import {PauseProviderBanner} from 'components/pages/restaurant/pause-provider-banner';
import {useCartContext} from 'components/providers';
import {useLocalStorageState, useTranslation} from 'hooks';
import {useRouter} from 'next/router';
import {useEffect} from 'react';
import {QueryKeyEnum, StorageKeyEnum} from 'types';
import {isProviderUnavalaible} from 'utils/cartUtils';
import {isTimestampGreaterThan15Mins} from 'utils/helpers';
import logger from 'utils/logger';

export const useRelevantCart = () => {
  const {cartProvider, timestamp, updateTimestamp, clearCart} = useCartContext();
  const {locale, push} = useRouter();
  const {t} = useTranslation();

  const [coordinatesAddress] = useLocalStorageState(StorageKeyEnum.COORDINATES);

  const {refetch} = useRestaurantBySlug(
    [QueryKeyEnum.RESTAURANT_BY_SLUG, cartProvider?.slug],
    {slug: `${cartProvider?.slug}`},
    {
      enabled: !!cartProvider?.slug,
      onSuccess: (data) => {
        if (!data) return;
        if (isProviderUnavalaible(data)) {
          if (!timestamp) return;
          try {
            let timestampDate = timestamp;
            if (!(timestamp instanceof Date)) {
              if (typeof timestamp === 'number') {
                timestampDate = new Date(timestamp);
              } else {
                logger.addBreadcrumb('isProviderUnavalaible invalid timestamp', {timestamp, type: typeof timestamp});
                return updateTimestamp();
              }
            }

            logger.addBreadcrumb('isProviderUnavalaible step2', {timestamp: timestampDate, slug: data.slug});

            const timestampMs = timestampDate instanceof Date ? timestampDate.getTime() : null;
            if (!timestampMs) return updateTimestamp();

            if (isTimestampGreaterThan15Mins(timestampMs)) onOpenPauseBanner();
          } catch (error) {
            logger.addBreadcrumb('isProviderUnavalaible error', {timestamp, error, nData: new Date()});
            updateTimestamp();
          }
        } else {
          updateTimestamp();
        }
      },
      refetchInterval: 60 * 1000 * 5,
    },
    locale ?? '',
    `${coordinatesAddress}`,
  );

  const {isOpen: isOpedPauseBanner, onOpen: onOpenPauseBanner, onClose: onClosePauseBanner} = useDisclosure();

  const handleCloseBanner = () => {
    onClosePauseBanner();
    clearCart(true);
    push('/');
  };

  useEffect(() => {
    if (!cartProvider) return;
    refetch();
  }, [refetch, cartProvider]);

  return {
    UnavailableProviderBanner: () => (
      <PauseProviderBanner
        isOpen={isOpedPauseBanner}
        onClose={handleCloseBanner}
        onConfirm={handleCloseBanner}
        name={cartProvider?.name ?? ''}
        providerType={cartProvider?.provider_type}
        message={cartProvider?.message}
        t={t}
      />
    ),
  };
};
